import gql from "graphql-tag";

export const getStudents = gql`
  query GetStudents {
    students {
      studentId
    }
  }
`;